export default state => state.licenseAgreements;